import { Navigate } from "react-router-dom";
import { getDefaultLocale } from "@/i18n";

export function LegacyPrivacyPolicyRedirect() {
  return <Navigate to={`/${getDefaultLocale()}/privacy-policy`} replace />;
}
